import { useEffect, useState } from 'react';
import { useAuth0, User } from '@auth0/auth0-react';
import { env } from '../../constants';

interface DomainClaims {
  email: string;
  identity: string[];
  uuid: string;
}

const API_AUDIENCE = env.VITE_API_BASE_URL;

export const useAccessToken = () => {
  const [token, setToken] = useState<string | undefined>(undefined);

  const { logout, isLoading, isAuthenticated, getAccessTokenSilently } =
    useAuth0();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      const getToken = async () => {
        try {
          const accessToken = await getAccessTokenSilently({
            authorizationParams: {
              audience: API_AUDIENCE
            }
          });

          setToken(accessToken);
        } catch (error) {
          console.error(`Could not get access token. ${String(error)}`);
          await logout({ logoutParams: { returnTo: window.location.origin } });
        }
      };

      void getToken();
    }
  }, [isLoading, isAuthenticated, logout, setToken, getAccessTokenSilently]);

  return { token, isLoading };
};

interface MyUser extends Omit<User, '[key: string]'> {
  [key: string]: DomainClaims | undefined;
}

export const useUserUUID = () => {
  const claims = 'https://zenjob.com';
  const { user } = useAuth0();

  const uuid = (user as MyUser)?.[claims]?.uuid;

  return uuid;
};
